import { render, staticRenderFns } from "./EditClub.vue?vue&type=template&id=d63d9b9a&"
import script from "./EditClub.vue?vue&type=script&lang=ts&"
export * from "./EditClub.vue?vue&type=script&lang=ts&"
import style0 from "./EditClub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports